module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-11-a92881c861e8f11a4eeb48c9b880f75a.webp";